<template>
  <div>
    <section class="project__steps project__steps--desktop">
      <div class="project__step project__step--1" :class="firstStepClass" @click="changeSteps(1)">
        Manage Details
      </div>
      <div class="project__step project__step--2" :class="secondStepClass" @click="changeSteps(2)">
        Learning Content
      </div>
      <div class="project__step project__step--3 project-sync__device" :class="thirdStepClass" @click="changeSteps(3)">
        Custom Channels
      </div>
    </section>

    <section v-on-click-outside="closeDropdown" class="project__steps project__steps--mobile">
      <div class="project__step project__step--mobile project__step--1" :class="firstStepClass" @click="onStepClick(1)">
        Manage Details
        <i class="fas project-step__chevron" :class="chevronClass"></i>
      </div>
      <div class="project__step project__step--mobile project__step--2" :class="secondStepClass" @click="onStepClick(2)">
        Learning Content
        <i class="fas project-step__chevron" :class="chevronClass"></i>
      </div>
      <div class="project__step project__step--mobile project__step--3" :class="thirdStepClass" @click="onStepClick(3)">
        Custom Channels
        <i class="fas project-step__chevron" :class="chevronClass"></i>
      </div>
    </section>

    <project-step-navigator :active="active" @next="$emit('next')" @prev="$emit('prev')" :project="project">
    </project-step-navigator>
  </div>
</template>

<script>
import { mixin as onClickOutside } from 'vue-on-click-outside';
import ProjectStepNavigator from "@/components/ProjectConnect/ProjectStepNavigator";

export default {
  mixins: [onClickOutside],
  name: "ProjectSteps",
  props: {
    project: Object,
    active: {
      type: Number,
      default: 1
    }
  },
  components: {
    ProjectStepNavigator,
  },
  data() {
    return {
      showDropdown: false,
      step2Visited: false,
      step3Visited: false,
    };
  },
  computed: {
    stepStatus() {
      return this.$store.getters['projectEdit/stepStatus'];
    },
    firstStepClass() {
      return this.step1Class(1);
    },
    secondStepClass() {
      return this.step2Class(2);
    },
    thirdStepClass() {
      return this.step3Class(3);  
    },
    chevronClass() {
      return {
        "fa-chevron-up": this.showDropdown,
        "fa-chevron-right": !this.showDropdown,
      };
    }
  },
  methods: {
    changeSteps(step) {
      if(step === 2) {
        this.step2Visited = true;
      } else if(step === 3) {
        this.step3Visited = true;
      }
      this.$emit('change', step);
    },
    closeDropdown() {
      this.showDropdown = false
    },
    onStepClick(step) {
      this.$emit("change", step);
      this.toggleDropdown();
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    step1Class(step) {
      return {
        "project__step--hide": !this.showDropdown && this.active !== step,
        "project__step--complete": this.stepStatus[step] === true,
        "project__step--active": this.active === step,
      };
    },
    step2Class(step) {
      return {
        "project__step--hide": !this.showDropdown && this.active !== step,
        "project__step--complete": this.stepStatus[step] === true,
        "project__step--active": this.active === step,
        "project__step2--visited": (this.stepStatus[step] === false && this.step2Visited),
      }
    },
    step3Class(step) {
      return {
        "project__step--hide": !this.showDropdown && this.active !== step,
        "project__step--complete": this.stepStatus[step] === true,
        "project__step--active": this.active === step,
        "project__step3--visited": (this.stepStatus[step] === false && this.step3Visited),
      }
    }
  }
};
</script>

<style scoped>
.project__steps {
  margin: var(--spacing-4);
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  font-weight: var(--bold);
  font-size: var(--xs);
  color: var(--grey);
}

.project__steps--mobile {
  display: none;
}

.project__step {
  cursor: pointer;
  flex: 1;
  padding: var(--spacing-4);
}

.project__step::before {
  color: var(--white);
  font-weight: var(--bold);
  margin-right: var(--spacing-2);
  padding: var(--spacing-1) var(--spacing-2);
  background-color: var(--rumie-green);
  border-radius: var(--border-radius-md);
}

.project__step--1::before {
  content: "1";
}

.project__step--2::before {
  content: "2";
}

.project__step--3::before {
  content: "3";
}

.project__step--active {
  background-color: var(--white);
  color: var(--black);
}

.project__step--complete {
  color: var(--black);
}

/* override some badge css */
.project__step > .badge,
.project__step.project__step::before {
  background-color: var(--rumie-green);
  display: inline-block;
  margin-left: var(--spacing-2);
  margin-top: var(--spacing-2);
}

.project__step--active > .badge,
.project__step--active.project__step::before {
  background-color: var(--rumie-green);
}

.project__step--complete > .badge,
.project__step--complete.project__step::before {
  background-color: var(--rumie-green) !important;
}

.project__step2--visited, .project__step3--visited {
  color: var(--black);
}

.project__step2--visited.project__step::before {
  background-color: var(--rumie-green);
}

.project__step3--visited.project__step::before {
  background-color: var(--rumie-green);
}

.project-sync__device {
  display: -webkit-box;
}

.project-sync__loader {
  align-items: center;
  margin-left: var(--spacing-2);
}

@media screen and (max-width: 1000px) {
  .project__steps--desktop {
    display: none;
  }

  .project__steps--mobile {
    background: var(--white);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .project__step {
    padding: var(--spacing-4) var(--spacing-1);
  }

  .project__step--hide {
    display: none;
  }

  .steps__dropdown--visible {
    display: block;
  }

  .project__step--mobile {
    background: var(--white);
    min-width: 200px;
    font-size: var(--sm);
  }

  .project__step--mobile > .project-step__chevron {
    display: none;
  }

  .project__step--active > .project-step__chevron {
    display: inline;
  }

  .fa-chevron-right,
  .fa-chevron-up {
    position: relative;
    top: 1px;
    left: var(--spacing-4);
    color: var(--grey-dark);
  }
}

@media screen and (max-width: 480px) {
  .project__step--mobile {
    font-size: var(--xs);
    min-width: 165px;
  }
}
</style>
